import { IconNoData100pxBoldS } from "@pionex-web-kit/icons";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import { jsx as _jsx } from "react/jsx-runtime";
var Simple = function Simple() {
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var prefixCls = getPrefixCls("empty-img-simple");
  return /*#__PURE__*/_jsx(IconNoData100pxBoldS, {
    className: prefixCls,
    size: 100
  });
};
export default Simple;